export function isServerSide(): boolean {
  return typeof window !== 'object';
}
